export default __webpack_public_path__ + "static/media/hero_bizz.e47c3209.svg";